module.exports = __webpack_public_path__ + "static/media/fundo-sonne.6de93583.png";